import { Box, Card, CardContent, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import SchoolIcon from '@mui/icons-material/School';
import {
  FilterContext,
  FilterList,
  FilterListItem,
  SearchInput,
} from 'react-admin';
import { SchoolElementaryIcon, SchoolHighIcon, SchoolMiddleIcon } from './components/school-icons';


export const productFilters = [
  <SearchInput source="q" alwaysOn />,
  // <ReferenceInput
  //     source="category_id"
  //     reference="categories"
  //     sort={{ field: 'id', order: 'ASC' }}
  // >
  //     <SelectInput source="name" />
  // </ReferenceInput>,
  // <NumberInput source="width_gte" />,
  // <NumberInput source="width_lte" />,
  // <NumberInput source="height_gte" />,
  // <NumberInput source="height_lte" />,
  // <QuickFilter
  //     label="resources.products.fields.stock_lte"
  //     source="stock_lte"
  //     defaultValue={10}
  // />,
];

const SchoolsFilter = () => {

  const isSelected = (value: { schoolType: string }, filters: { schoolTypes: Array<string> }) => {
    const schoolsTypes = filters.schoolTypes || [];
    return schoolsTypes.includes(value.schoolType);
  };

  const toggleFilter = (value: { schoolType: string }, filters: { schoolTypes: Array<string> }) => {
    const schoolTypes = filters.schoolTypes || [];
    return {
      ...filters,
      schoolTypes: schoolTypes.includes(value.schoolType)
        // Remove the category if it was already present
        ? schoolTypes.filter(v => v !== value.schoolType)
        // Add the category if it wasn't already present
        : [...schoolTypes, value.schoolType],
    };
  };

  return (
    <Card
      sx={{
        display: { xs: 'none', md: 'block' },
        order: -1,
        alignSelf: 'flex-start',
      }}
    >
      <FilterContext.Provider value={productFilters}>
        <CardContent sx={{ pt: 1 }}>
          {/* <FilterLiveSearch hiddenLabel /> */}

          {/* <SavedQueriesList /> */}

          <FilterList
            label="Type"
            icon={<SchoolIcon />}
          >
            <FilterListItem
              label={
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} >
                  <SchoolHighIcon />
                  <Typography variant="inherit" marginLeft={1}>High</Typography>
                </Box>
              }
              value={{ schoolType: 'high' }}
              isSelected={isSelected}
              toggleFilter={toggleFilter}
            />
            <FilterListItem
              label={
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} >
                  <SchoolMiddleIcon />
                  <Typography variant="inherit" marginLeft={1}>Middle</Typography>
                </Box>
              }
              value={{ schoolType: 'middle' }}
              isSelected={isSelected}
              toggleFilter={toggleFilter}
            />
            <FilterListItem
              label={
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} >
                  <SchoolElementaryIcon />
                  <Typography variant="inherit" marginLeft={1}>Elementary</Typography>
                </Box>
              }
              value={{ schoolType: 'elementary' }}
              isSelected={isSelected}
              toggleFilter={toggleFilter}
            />
          </FilterList>

          <FilterList
            label="Rating"
            icon={<StarIcon />}
          >
            <FilterListItem label="Rating above 9" value={{ rating: 9 }} />
            <FilterListItem label="Rating above 8" value={{ rating: 8 }} />
            <FilterListItem label="Rating above 7" value={{ rating: 7 }} />
            <FilterListItem label="Rating above 6" value={{ rating: 6 }} />
            <FilterListItem label="Rating above 5" value={{ rating: 5 }} />
            <FilterListItem label="Rating above 4" value={{ rating: 4 }} />
            <FilterListItem label="Rating above 3" value={{ rating: 3 }} />
            <FilterListItem label="Rating above 2" value={{ rating: 2 }} />
            <FilterListItem label="Rating above 1" value={{ rating: 1 }} />
          </FilterList>

        </CardContent>
      </FilterContext.Provider>
    </Card>
  );
};

export default SchoolsFilter;
